import { gql } from 'graphql-request'
import { BlockCta } from '../queries/block-cta'
import { QueryBenefitBlock } from '../queries/benefit-block'
import { BlockIntegrationsFiltering } from '../queries/block-filter'
import { BlockRequestForm } from '../queries/block-request-form'
import { BlockUspList } from '../queries/block-usp-list'
import { BlockLogos } from '../queries/block-logos'
import { BlockIntegrationListing } from '../queries/block-integration-listing'
import { Block3CardsWithImage } from '../queries/block-3-cards-with-image'
import { BlockCustomersTop } from '../queries/customers-top'
import { BlockBenefitsListing } from '../queries/block-benefits-listing'
import { BlockHeroHomeTwo } from '../queries/block-hero-home-two'
import { BlockTeamMembers } from '../queries/block-team-members'
import { BlockPricingCards } from '../queries/block-pricing-cards'
import { BlockFeatureContact } from '../queries/block-feature-contact'
import { BlockFeatureSimple } from '../queries/block-feature-simple'
import { BlockFeatureList } from '../queries/block-feature-list'
import { BlockSummary } from '../queries/block-summary'
import { BlockCrissCross } from '../queries/block-crisscross'
import { BlockBlogTop } from '../queries/block-blog-top'
import { BlockFaqTop } from '../queries/block-faq-top'
import { BlockHeroDual } from '../queries/block-hero-dual'
import { QueryNavigationItem } from '../queries/navigation-element'
import { HubSpotCalendar } from '../queries/block-hubspot-calendar'
import { BlockOffices } from '../queries/block-offices'
import { BlockRichText } from '../queries/block-richtext'
import { BlockSectionHeader } from '../queries/block-section-header'
import { BlockRelatedArticles } from '../queries/block-related-articles'
import { Block2ColumnsIntegrationList } from '../queries/block-two-columns-integration'
import { QueryVideo } from '../queries/video'
import { QuerySimpleBlock } from '../queries/simple-block'
import { QueryFeatureCardBlock } from '../queries/feature-card-block'
import { QueryFormattedTextBlock } from '../queries/formatted-text-block'
import { QueryHubspotForm } from './hubspot-form'
import { QueryLogo } from './logos'
import { QueryTeamMember } from './team-member'
import { ResponsiveImage } from './responsive-image'
import { FragmentLinkReferences } from './references'

const models = {
  BLOCKFEATURELIST: BlockFeatureList,
  BLOCKSUMMARY: BlockSummary,
  BLOCKFEATURESIMPLE: BlockFeatureSimple,
  BLOCKINTEGRATIONSFILTERING: BlockIntegrationsFiltering,
  BLOCKTEAMMEMBERS: BlockTeamMembers,
  BLOCKFEATURECONTACT: BlockFeatureContact,
  BLOCKPRICINGCARDS: BlockPricingCards,
  BLOCKREQUESTFORM: BlockRequestForm,
  BLOCKUSPLIST: BlockUspList,
  BLOCKLOGOS: BlockLogos,
  BLOCKINTEGRATIONLISTING: BlockIntegrationListing,
  BLOCK3CARDSWITHIMAGE: Block3CardsWithImage,
  BLOCKHEROHOMETWO: BlockHeroHomeTwo,
  BLOCKBENEFITSLISTING: BlockBenefitsListing,
  BLOCKCUSTOMERSTOP: BlockCustomersTop,
  BLOCKCRISSCROSS: BlockCrissCross,
  BLOCKRELATEDARTICLES: BlockRelatedArticles,
  BLOCKSECTIONHEADER: BlockSectionHeader,
  BLOCKCTA: BlockCta,
  BLOCKRICHTEXT: BlockRichText,
  BLOCKHERODUAL: BlockHeroDual,
  BLOCK2COLUMNSINTEGRATIONLIST: Block2ColumnsIntegrationList,
  BLOCKOFFICES: BlockOffices,
  HUBSPOTCALENDAR: HubSpotCalendar,
  BLOCKFAQTOP: BlockFaqTop,
  BLOCKBLOGTOP: BlockBlogTop
}

const queryFragments = {
  FragmentNavigationItem: QueryNavigationItem,
  QueryVideo: QueryVideo,
  FragmentSimpleBlock: QuerySimpleBlock,
  FragmentFormattedTextBlock: QueryFormattedTextBlock,
  FragmentFeatureCardBlock: QueryFeatureCardBlock
}

export const pageQueryBuilder = (typenames = new Set()) => {
  const componentsFragments = []
  const fragmentsArr = []
  let fragmentsQuery = ``
  let components = ``
  typenames.forEach((t) => {
    if (!models[t]) return
    components += `
      ... on ${models[t].__typename} {
        ...${models[t].fragmentName}
      }
    `
    componentsFragments.push(models[t].fragmentQuery)
    fragmentsArr.push(...models[t].fragments)
  })

  const fragmentsSet = new Set([...fragmentsArr.flat(), 'FragmentNavigationItem'])

  fragmentsSet.forEach((f) => {
    fragmentsQuery += `
      ${queryFragments[f]}
    `
  })

  const queryTemplate = gql`query GetContentBySlug($id: String!, $locale: String!) {
    page(id: $id, locale: $locale) {
      sys {
        id
      }
      title
      slug
      minimalHeader
      minimalHeaderAction {
        ...FragmentNavigationItem
      }
      enabledLocales
      minimalFooter
      metaTags
      marketsMetaTags
      metaImage {
        url
      }
      alternativeHeader {
        sys {
          id
        }
      }
      componentsCollection(limit: 20) {
        items {
          ${components}
        }
      }
    }
  }
  ${componentsFragments}
  ${fragmentsQuery}
`

  return queryTemplate
}


export const datoPageContentQuery = () => {
  const modelArray = {
    BlockFeatureList,
    BlockSummary,
    BlockFeatureSimple,
    BlockIntegrationsFiltering,
    BlockTeamMembers,
    BlockFeatureContact,
    BlockPricingCards,
    BlockRequestForm,
    BlockUspList,
    BlockLogos,
    BlockIntegrationListing,
    Block3CardsWithImage,
    BlockHeroHomeTwo,
    BlockBenefitsListing,
    BlockCustomersTop,
    BlockCrissCross,
    BlockRelatedArticles,
    BlockSectionHeader,
    BlockCta,
    BlockRichText,
    BlockHeroDual,
    Block2ColumnsIntegrationList,
    BlockOffices,
    HubSpotCalendar,
    BlockFaqTop,
    BlockBlogTop,
  }

  // Get all fragment queries from modelArray
  const fragmentQueries = Object.values(modelArray)
    .map(model => model.fragmentQuery)
    .filter(Boolean)
    .join('\n')

  // Additional fragment queries
  const additionalFragments = [
    QueryNavigationItem,
    QueryVideo,
    QuerySimpleBlock,
    QueryFormattedTextBlock,
    QueryFeatureCardBlock,
    QueryBenefitBlock,
    QueryHubspotForm,
    QueryLogo,
    QueryTeamMember,
    ResponsiveImage,
    FragmentLinkReferences
  ].filter(Boolean).join('\n')

  const pageContentQuery = `query pageContenQuery($slug: String!, $marketId: [ItemId]!, $locale: SiteLocale, $componentsLocale: SiteLocale) {
    pageModel(locale: $locale, fallbackLocales: en, filter: { slug: { eq: $slug }, enabledMarkets: { anyIn: $marketId} }) {
      id
      title
      slug
      _allSlugLocales {
        locale
        value
      }
      enabledMarkets {
        countryIsoCode
        enabledLanguages
        defaultLanguage
        _allSlugPrefixLocales {
          locale
          value
        }
      }
      _allEnabledLocalesLocales {
        locale
        value
      }
      alternativeHeader {
        id
      }
      metaTags(locale: $componentsLocale, fallbackLocales: en)
      marketsMetaTags(locale: $componentsLocale, fallbackLocales: en)
      metaImage {
        url
      }
      minimalHeader
      minimalHeaderAction {
        ...FragmentNavigationItem
      }
      components(locale: $componentsLocale, fallbackLocales: en) {
        ...FragmentBenefitBlock
        ...FragmentBlock3CardsWithImage
        ...FragmentBlockBenefitsListing
        ...FragmentBlockBlogTop
        ...FragmentBlockCrissCross
        ...FragmentBlockCta
        ...FragmentBlockFaqTop
        ...FragmentBlockFeatureContact
        ...FragmentBlockFeatureList
        ...FragmentBlockFeatureSimple
        ...FragmentBlockFiltering
        ...FragmentBlockHeroDual
        ...FragmentBlockHeroHomeTwo
        ...FragmentBlockHubSpotCalendar
        ...FragmentBlockIntegrationListing
        ...FragmentBlockLogos
        ...FragmentBlockOffices
        ...FragmentBlockPricingCards
        ...FragmentBlockRelatedArticles
        ...FragmentBlockRequestForm
        ...FragmentBlockRichText
        ...FragmentBlockSectionHeader
        ...FragmentBlockSummary
        ...FragmentBlockTeamMembers
        ...FragmentBlock2ColumnsIntegrationList
        ...FragmentBlockUspList
        ...FragmentBlockCustomersTop
        ...FragmentHubspotForm
        ...FragmentLogos
      }
    }
  }
  ${fragmentQueries}
  ${additionalFragments}
  `
  return pageContentQuery
}